// React Lazily
import { lazily } from 'react-lazily'

// Interfaces
import { IRoute } from 'routes/route.interface'

// Constant
import { CONTENT_URL, CONTENT_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { ContentGalleryIndex } = lazily(() => import('pages/back-office/content-management/gallery'))

const contentGalleryRoutes: IRoute[] = [
  {
    path: CONTENT_URL.GALLERY,
    component: ContentGalleryIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: CONTENT_MODULE,
      requireAuth: true,
      attrs: { label: 'contentManagementGallery.gallery.gallery', accessCodes: [557] },
    },
  },
]

export { contentGalleryRoutes }
